import { $api } from '@service/RequestService';
import { Pagination } from '@utils/models/Pagination';
import { stringifyUrl } from 'query-string';
import { useInfiniteQuery } from 'react-query';

import { realtorConstants, realtorModels } from '..';

export const useCompanyRealtorSuggestionInfinity = (
  props: {
    flatId?: number;
    search?: string;
  } = {}
) =>
  useInfiniteQuery<Pagination<realtorModels.ICompanyRealtorSuggestion>>({
    queryKey: [realtorConstants.queryKeys.COMPANY_REALTOR_SUGGESTION, props],
    queryFn: async ({ pageParam }) => {
      const res = await $api.get(
        stringifyUrl({
          url: '/v1/company/realtor/suggestion',
          query: {
            ...props
          }
        })
      );

      return res.data.data;
    },
    getNextPageParam: (lastPage, page) => {
      if (page.length < lastPage?.totalPages) {
        return page.length + 1;
      }
      return undefined;
    },
    enabled: !!props.flatId
  });
